module.exports = __webpack_public_path__ + "img/WhatsApp-4.3e785e9f.jpeg";